<template>
  <div
    class="main2-content"
    style="top: 0px; background: #ffffff; z-index: 1"
    :style="stylePosition"
  >
    <div class="panel-content">
      <div class="roll-content">
        <div class="roll-icon-left" @click="handleLeft">
          <i class="el-icon-caret-left"></i>
        </div>
        <div
          class="width-roll"
          ref="roll"
          :style="{ width: clientWidth + 'px' }"
        >
          <div :style="widthTranslate">
            <div style="white-space: nowrap; width: max-content">
              <div
                class="menu"
                v-for="(item, index) in menu"
                :key="index"
                :style="{
                  background: index == btnIndex ? item.color : '',
                  color: index == btnIndex ? '#fff' : '',
                }"
                @click="handleMenu(index)"
              >
                <div class="btn">
                  <div>{{ item.name }}</div>
                  <div>{{ item.nameEn }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="roll-icon-right" @click="handleRight">
          <i class="el-icon-caret-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config1";
export default {
  components: {},
  data() {
    return {
      ...config,
      btnIndex: 0,
      activeNames: 0,
      activeNames1: 0,
      activeNames2: 0,
      activeNames3: 0,
      menu: [
        {
          name: "良好健康与福祉",
          nameEn: "Good Health and Well-being",
          to: "",
          color: "#5fb66e",
        },
        {
          name: "优质教育",
          nameEn: "Quality Education",
          to: "",
          color: "#c4202e",
        },
        {
          name: "清洁饮水和卫生设施",
          nameEn: "Clean Water and Sanitation",
          to: "",
          color: "#50bec5",
        },
        {
          name: "经济适用的清洁能源",
          nameEn: "Affordable and Clean Energy",
          to: "",
          color: "#F9C213",
        },
        {
          name: "体面工作和经济增长",
          nameEn: "Decent Work and Economic Growth",
          to: "",
          color: "#a11c44",
        },
        {
          name: "产业、创新和基础设施",
          nameEn: "Industry, Innovation and Infrastructure",
          to: "",
          color: "#e1b253",
        },
        {
          name: "可持续城市和社区",
          nameEn: "Sustainable Cities and Communities",
          to: "",
          color: "#5fb66e",
        },
        {
          name: "负责任消费和生产",
          nameEn: "Responsible Consumption and Production",
          to: "",
          color: "#e19b40",
        },
        {
          name: "促进目标实现的伙伴关系",
          nameEn: "Partnerships for the Goal",
          to: "",
          color: "#3b9bbb",
        },
      ],
      // 视图可见宽度
      clientWidth: 1300,
      endMove: -1440,
      // 控制触边值
      rollclientWidth: 1300,
      // 移动距离
      toMove: 0,
      // 滚动条距离顶部距离
      toScrollTop: 0,
      // 各种板块高度
      bannerBgHeight: 0,
      scene1: 0,
      scene2: 0,
      scene3: 0,
      scene4: 0,
      scene5: 0,
      scene6: 0,
      scene7: 0,
      scene8: 0,
      scene9: 0,
    };
  },
  computed: {
    widthTranslate() {
      return `transform: translate(${this.toMove}px, 0px)`;
    },
    stylePosition() {
      if (this.toScrollTop > 700) {
        return `position: fixed`;
      } else {
        return `position: relative;`;
      }
    },
  },
  beforeMount() {
    let _w = document.documentElement.clientWidth || document.body.clientWidth;
    console.log(_w);
    if (_w <= 1400) {
      this.clientWidth = 1100;
      this.endMove = -1640;
    } else {
      this.clientWidth = 1300;
      this.endMove = -1440;
    }
  },
  mounted() {
    window.onscroll = () => {
      this.toScrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      console.log("当前滚动条高度", this.toScrollTop);
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      console.log(_w);
      if (_w <= 1400) {
        this.getMenu();
      } else {
        this.getMenu();
      }
    };
  },
  methods: {
    getHeight() {
      // this.bannerBgHeight = document.getElementById("bannerBg").height;
      // this.scene1 = document.getElementById("scene1").height;
      // this.scene2 = document.getElementById("scene2").height;
      // this.scene3 = document.getElementById("scene3").height;
      // this.scene4 = document.getElementById("scene4").height;
      // this.scene5 = document.getElementById("scene5").height;
      // this.scene6 = document.getElementById("scene6").height;
      // this.scene7 = document.getElementById("scene7").height;
      // this.scene8 = document.getElementById("scene8").height;
      // this.scene9 = document.getElementById("scene9").height;
    },
    // 小于1400px的滚动条和菜单计算
    getMenu() {
      let toScrollTop = this.toScrollTop;
      // 矫正高度，导航栏前面的高度
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      console.log(_w);
      let obg = document.getElementById("bannerBg").offsetHeight;
      let o = document.getElementById("scene1").offsetHeight;
      let o1 = document.getElementById("scene2").offsetHeight;
      let o2 = document.getElementById("scene3").offsetHeight;
      let o3 = document.getElementById("scene4").offsetHeight;
      let o4 = document.getElementById("scene5").offsetHeight;
      let o5 = document.getElementById("scene6").offsetHeight;
      let o6 = document.getElementById("scene7").offsetHeight;
      let o7 = document.getElementById("scene8").offsetHeight;
      let o8 = document.getElementById("scene9").offsetHeight;
      console.log("js", obg, o, o1, o2, o3, o4, o5, o6, o7, o8);
      let baseHeight = 110 + obg - 60;
      let height = baseHeight + o;
      let height1 = height + o1;
      let height2 = height1 + o2;
      let height3 = height2 + o3;
      let height4 = height3 + o4;
      let height5 = height4 + o5;
      let height6 = height5 + o6;
      let height7 = height6 + o7;
      let height8 = height7 + o8;
      if (toScrollTop < height) {
        // 板块高度 960
        this.btnIndex = 0;
        this.toMove = 0;
      } else if (toScrollTop < height1) {
        // 板块高度 710
        this.btnIndex = 1;
        this.toMove = -200;
      } else if (toScrollTop < height2) {
        // 板块高度 1050
        this.btnIndex = 2;
        this.toMove = -400;
      } else if (toScrollTop < height3) {
        // 板块高度 1040
        this.btnIndex = 3;
        this.toMove = -600;
      } else if (toScrollTop < height4) {
        // 板块高度 1100
        this.btnIndex = 4;
        this.toMove = -800;
      } else if (toScrollTop < height5) {
        // 板块高度 1240
        this.btnIndex = 5;
        this.toMove = -1000;
      } else if (toScrollTop < height6) {
        // 板块高度 710
        this.btnIndex = 6;
        this.toMove = -1200;
      } else if (toScrollTop < height7) {
        // 板块高度 980
        this.btnIndex = 7;
        this.toMove = -1640;
      } else if (toScrollTop < 10000) {
        // 板块高度 830
        this.btnIndex = 8;
        this.toMove = -1640;
      }
    },
    // 大于1400px的滚动条和菜单计算
    getMenu2() {
      let toScrollTop = this.toScrollTop;
      // 矫正高度，导航栏前面的高度
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      console.log(_w);
      let baseHeight = 700;
      if (_w <= 1440) {
        baseHeight = 700;
      } else if (_w <= 1600) {
        baseHeight = 770;
      } else if (_w <= 1800) {
        baseHeight = 855;
      } else if (_w <= 1920) {
        baseHeight = 910;
      } else {
        baseHeight = 980;
      }
      let height = baseHeight + 955;
      let height1 = height + 710;
      let height2 = height1 + 1050;
      let height3 = height2 + 1040;
      let height4 = height3 + 1100;
      let height5 = height4 + 1240;
      let height6 = height5 + 710;
      let height7 = height6 + 980;
      let height8 = height7 + 830;
      if (toScrollTop < height) {
        // 板块高度 960
        this.btnIndex = 0;
        this.toMove = 0;
      } else if (toScrollTop < height1) {
        // 板块高度 710
        this.btnIndex = 1;
        this.toMove = -200;
      } else if (toScrollTop < height2) {
        // 板块高度 1050
        this.btnIndex = 2;
        this.toMove = -400;
      } else if (toScrollTop < height3) {
        // 板块高度 1040
        this.btnIndex = 3;
        this.toMove = -600;
      } else if (toScrollTop < height4) {
        // 板块高度 1100
        this.btnIndex = 4;
        this.toMove = -800;
      } else if (toScrollTop < height5) {
        // 板块高度 1240
        this.btnIndex = 5;
        this.toMove = -1000;
      } else if (toScrollTop < height6) {
        // 板块高度 710
        this.btnIndex = 6;
        this.toMove = -1440;
      } else if (toScrollTop < height7) {
        // 板块高度 980
        this.btnIndex = 7;
        this.toMove = -1440;
      } else if (toScrollTop < 10000) {
        // 板块高度 830
        this.btnIndex = 8;
        this.toMove = -1440;
      }
    },
    //文字向右移动
    handleLeft() {
      console.log("当前偏移量：", this.toMove);
      // 阈值控制触边
      if (this.toMove + 400 >= 0) {
        console.log("宽度触左边");
        this.toMove = 0;
      } else {
        this.toMove = this.toMove + 400;
      }
    },
    //文字向左移动
    handleRight() {
      console.log("当前偏移量：", this.toMove);
      // 阈值控制触边
      if (this.toMove - 400 <= this.endMove) {
        console.log("宽度触右边");
        this.toMove = this.endMove;
      } else {
        this.toMove = this.toMove - 400;
      }
    },
    //回到偏远量为0
    handleReset() {
      this.toMove = 0;
    },
    layoutShow(val = 0) {
      if (val == this.btnIndex) {
        return true;
      } else {
        return false;
      }
    },
    handleMenu(index) {
      this.btnIndex = index;
      // var anchor = this.$root.$el.querySelector("#scene" + (index + 1));
      // document.body.scrollTop = anchor.offsetTop;
      // 跳转到对应板块
      console.log($("#scene" + (index + 1)));
      document.querySelector("#scene" + (index + 1)).scrollIntoView(true);
      // 滚动条回滚50px
      let scrollTop = $(document).scrollTop();
      $(document).scrollTop(scrollTop - 30);
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./common.less");

.menu {
  color: #999999;
  text-align: center;
  transform: skewX(-45deg);
  display: inline-block;
  margin-left: 30px;
  padding: 10px 30px;
  cursor: pointer;
  .btn {
    transform: skewX(45deg);
  }
}
.panel-content {
  padding: 0px;
}
.roll-content {
  position: relative;
  .width-roll {
    width: 1300px;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
  }
  .roll-icon-left {
    color: #999999;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    line-height: 60px;
    font-size: 24px;
  }
  .roll-icon-right {
    color: #999999;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    line-height: 60px;
    font-size: 24px;
  }
}
</style>
